import detailPop from './detailPop.vue';
import popMgr from '../popMgr';

export default {
    open(link, animation) {
        // 弹框之前先保存当前url(之后会改成link, 用于分享, 收起的时候还原)
        if (this.popIns && !this.popIns._destroyFlag) {
            this.popIns.setAnimation(animation);
            this.popIns.setEnableAnimation(true);
            this.popIns.setLink(link);
            this.popIns.display(true);
        } else {
            this.popIns = popMgr.create(detailPop, { animation });
            this.popIns.setLink(link);
        }
    }
};
